import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService } from '../../services';
import { SOTDialogService } from '../../services';
import { SOTStartpageViewModel } from '../../models/startpage.model';
import { orderTypes } from '../../../core/shared/contentTypes';

@Component({
  selector: "sot-ordertype",
  templateUrl: "./ordertype.component.html",
  styleUrls: ["./ordertype.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderTypeComponent implements OnInit, OnDestroy {

  public startpageViewModels: SOTStartpageViewModel[];
  public accessabiltyoptions: boolean;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService
    , private _dialogService: SOTDialogService
  ) {
    console.debug("--- sot-ordertype constructor")

  }
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;

  public ngOnInit(): void {
    const me = this;
    me.startpageViewModels = me._sotService.GetStartpages();
    me._sotService.storeInitialColorsAndFontSizes();
    me.PushChanges();
  }

  public async openAccessabiltyDialog(): Promise<void> {
    const me = this;
    try {
      const result = await me._sotService.openAccessabiltyDialog(me.isModeOne, me.isModeTwo);

      if (result) {
        if (result.useModeOne !== undefined) {
          me._sotService.Accessabilty.SetModeOne(result.useModeOne);
          me.isModeOne = result.useModeOne;
        }
        if (result.useModeTwo !== undefined) {
          me._sotService.Accessabilty.SetModeTwo(result.useModeTwo);
          me.isModeTwo = result.useModeTwo;
          me._sotService.updateCssVariables(me.isModeTwo);
        }
        me.PushChanges();
      }
    } catch (error) {
      console.error('Error opening accessibility dialog:', error);
    }
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-ordertype ngOnDestroy")
  }
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("OrderTypeComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public get has_logo_image(): boolean {
    return this._sotService.GetSettings().has_logo_image;
  }

  public get logo_image_path(): string {
    return this._sotService.GetSettings().logo_image_path;
  }

  public get hasInHouseOption(): boolean {
    return this._sotService.hasInHouseOption;
  }

  public chooseOrderTypeInHouse() {
    this._sotService.GoToMenu(orderTypes.inHouse);
  }

  public get hasPickupOption(): boolean {
    return this._sotService.hasPickupOption;
  }

  public chooseOrderTypePickup() {
    this._sotService.GoToMenu(orderTypes.pickup);
  }

  public get allow_langauge_select(): boolean {
    return this._sotService.GetSettings().languages.length > 1;
  }

  public get languageText(): string {
    return this._sotService.GetSettings().languages.map((language_key) => this._sotService.TranslateKeyToLanguage(language_key, "button_language")).join(" / ");
  }

  public get languages(): { key: string, image: string, active: boolean }[] {
    const current_language = this._sotService.GetCurrentLanguage();
    const sotSettings = this._sotService.GetSettings();
    return sotSettings.languages.map((language_key) => ({ key: language_key, image: sotSettings.getLanguageFlagUrl(language_key), active: language_key == current_language }));
  }

  public getLanguageImage(key: string): string {
    return;
  }

  public chooseLanguage(language: string): void {
    const me = this;
    me._sotService.ChangeLanguage(language).then((changed) => {
      if (changed) {
        me.PushChanges();
      } // else no changes
    }).catch((error) => {
      me._sotService.coreLogService.error("OrderTypeComponent.chooseLanguage", "ChangeLanguage catch", error);
    });
  }
}

